export default "__VITE_ASSET__d49fab3d__"